<template>
    <div>
        <b-row>
            <b-col align-h="center" cols="12" md="12" lg="12">
                <app-form-select-input
                    label="Sede"
                    :options="venues"
                    v-model="riskAnalysis.venueId"
                    :required="true"
                    :hasError="$v.riskAnalysis.venueId.$error"
                    errorMessage="Debe seleccionar la sede"
                    @change="$v.riskAnalysis.venueId.$touch()"
                />
            </b-col>
            <b-col cols="12" md="12" lg="12">
                <app-form-textarea-input
                    label="Notas"
                    id="notes"
                    v-model="riskAnalysis.notes"
                />
            </b-col>
            <b-col cols="12" md="12" lg="12">
                <div class="form-group">
                    <label for=""
                        >Proxima actualización
                        <span class="field-required-mark">*</span></label
                    >
                    <app-datepicker
                        class="form-control"
                        v-model="nextUpdate"
                        id="nextUpdate"
                        :format="customFormatter"
                        :language="es"
                        :minimumView="'month'"
                        :maximumView="'year'"
                        :initialView="'year'"
                        :disabledDates="disabledDates"
                    />
                    <span
                        v-if="$v.riskAnalysis.nextUpdate.$error"
                        class="field-error"
                        >Debe indicar una fecha de proxima actualización</span
                    >
                </div>
            </b-col>
            <b-col cols="12" md="12" lg="12">
                <b-card
                    title="Archivo de análisis de seguridad"
                    tag="article"
                    style="max-width: 100%;"
                    class="mb-2"
                >
                    <div class="card-text">
                        <b-form-file
                            v-model="riskAnalysis.file"
                            :state="Boolean(riskAnalysis.file)"
                            placeholder="Seleccione el archivo de análisis de seguridad"
                            ref="fileinput"
                        ></b-form-file>
                        <div v-if="riskAnalysis.file" class="mt-3">
                            Archivo seleccionado:
                            {{ riskAnalysis.file && riskAnalysis.file.name }}
                        </div>
                    </div>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import riskAnalysisRepository from '../../../../repositories/riskAnalysis.repository'
import { required } from 'vuelidate/lib/validators'
import Datepicker from 'vuejs-datepicker'
import { es } from 'vuejs-datepicker/dist/locale'

export default {
    components: {
        appDatepicker: Datepicker,
    },

    props: {
        onSave: {
            type: Function,
        },
        venues: {
            type: Array,
            required: true,
        },
        myRiskAnalysis: {
            default: null,
        },
    },

    data() {
        return {
            riskAnalysis: {
                venueId: '',
                userId: '',
                notes: '',
                nextUpdate: '',
                file: null,
            },
            nextUpdate: '',
            es: es,
            disabledDates: {
                to: new Date(),
            },
        }
    },

    validations: {
        riskAnalysis: {
            venueId: { required },
            nextUpdate: { required },
            file: { required },
        },
    },

    watch: {
        nextUpdate(val) {
            this.riskAnalysis.nextUpdate = moment(val).format('DD/MM/YYYY')
        },
    },

    methods: {
        saveRiskAnalysis() {
            this.$v.riskAnalysis.$touch()
            if (this.$v.riskAnalysis.$invalid) {
                toastr.error(
                    'Debe diligenciar correctamente todos los campos obligatorios'
                )
                return false
            }

            const formData = new FormData()

            formData.append('userId', this.user.id)
            formData.append('notes', this.riskAnalysis.notes)
            formData.append('venueId', this.riskAnalysis.venueId)
            formData.append('nextUpdate', this.riskAnalysis.nextUpdate)

            if (this.riskAnalysis.file) {
                formData.append('file', this.riskAnalysis.file)
            }

            const rar = { ...riskAnalysisRepository }
            rar.saveRiskAnalysis(formData)
                .then(data => {
                    if (data.status) {
                        toastr.success(data.msg)
                        typeof this.onSave === 'function' && this.onSave()
                    } else {
                        toastr.error(data.msg)
                    }
                })
                .catch(error => {
                    toastr.error(
                        'Ocurrió un error al cargar el análisis de seguridad'
                    )
                })
        },
        customFormatter(date) {
            return moment(date).format('MM/YYYY')
        },
        cleanFields() {
            this.nextUpdate = ''
            Object.keys(this.riskAnalysis).map(
                key => key !== 'file' && (this.riskAnalysis[key] = '')
            )
            this.riskAnalysis.file = null
            this.$refs.fileinput.reset()
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },
    },
    created() {
        this.$bus.$on('risk-analysis-form.save', this.saveRiskAnalysis)
        this.$bus.$on('risk-analysis-form.clean', this.cleanFields)
    },
    beforeDestroy() {
        this.$bus.$off('risk-analysis-form.save')
    },
}
</script>

<style>
#nextUpdate {
    width: 100%;
    border-color: transparent transparent;
}

.custom-file-input:lang(es) ~ .custom-file-label::after {
    content: 'Buscar';
}
</style>
